import React from 'react';
import ProtectedRoute from './ProtectedRoute';
import PageLayout from '../shared/PageLayout';

const PageRoute = ({ component: Component, ...rest }) => (
  <ProtectedRoute
    {...rest}
    render={props => (
      <PageLayout>
        <Component {...props} />
      </PageLayout>
    )} />
);

export default PageRoute;



// WEBPACK FOOTER //
// ./src/components/routes/PageRoute.js